<template>
  <div class="page">

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped>
.page{
  height:100%;
  background-color:rgba(0,0,0,0.4);
}
</style>
